import React from "react";
const UserFilter = (props) => {
    return (
        <React.Fragment>
            <div
                className="container my-4"
                style={{
                    padding: "25px",
                    borderRadius: "15px",
                    border: "1px solid rgb(219, 219, 219)",
                }}
            >
                <div className="row">
                    <div className="col-6 text-center">
                        <span className="d-inline-block"> جستجوی واژه</span>
                        <input
                            type="text"
                            className="form-control d-inline-block"
                            value={props.search}
                            onChange={props.changeSearch}
                        />
                    </div>
                    <div className="col-6 text-center">
                        <span className="d-inline-block">
                            {" "}
                            آنهایی که نتیجه :
                        </span>
                        <select
                            value={props.hasResult}
                            onChange={props.changeHasResult}
                            className="form-control d-inline-block"
                        >
                            <option value="">داشتند / نداشتند</option>
                            <option value={1}>داشتند</option>
                            <option value={0}>نداشتند</option>
                        </select>
                    </div>
                    <div className="col mt-4">
                        <div
                            className="btn btn-block btn-info"
                            onClick={props.apply}
                        >
                            فیلتر{" "}
                        </div>
                    </div>
                </div>
            </div>
            |
        </React.Fragment>
    );
};
export default UserFilter;
